/** Spacer heights (`.zwdoc` `spacer` nodes; legacy `<!-- zw-spacer -->` markers). */

export const DEFAULT_SPACER_HEIGHT = "2em";
export const MIN_SPACER_EM = 0.5;
export const MAX_SPACER_EM = 40;

export type SpacerHeight = {
  value: number;
  unit: "em" | "px" | "rem";
};

export function formatSpacerHeight(height: SpacerHeight): string {
  const rounded =
    height.unit === "px"
      ? Math.round(height.value)
      : Math.round(height.value * 100) / 100;
  const text =
    Number.isInteger(rounded) || height.unit === "px"
      ? String(rounded)
      : rounded.toFixed(2).replace(/\.?0+$/, "");
  return `${text}${height.unit}`;
}

/** Snap a pixel delta into em, given the editor's font size. */
export function snapSpacerEm(em: number): number {
  const stepped = Math.round(em * 4) / 4;
  return Math.min(MAX_SPACER_EM, Math.max(MIN_SPACER_EM, stepped));
}
